export default "__VITE_ASSET__Dw$Labsp__"